import { call, put, takeEvery } from 'redux-saga/effects';
import { CreateOrderApi, GetAllOrderApi, GetAllCancelledOrderApi, GetOrderByIdApi, CreatePaymentLinkApi } from '../../utils/api';
import { handleApiResponse } from '../../utils/functions';
import {
  CREATE_ORDER,
  GET_ALL_ORDER_LIST,
  GET_ALL_PENDING_ORDER_LIST,
  GET_ALL_CANCELLED_ORDER_LIST,
  GET_ORDER_BY_ID,
} from '../storeTypes';
import {
  ActionGetAllOrderListSuccess,
  ActionGetAllPendingOrderListSuccess,
  ActionGetAllCancelledOrderListSuccess,
  ActionGetOrderByIDSuccess,
} from '../Actions/OrderHistoryAction';

const File = 'OrderHistorySaga';

function* GetAllOrderSaga(action) {
  try {
    const response = yield call(GetAllOrderApi, action.payload);
    if (response?.status === 200) {
      yield put(ActionGetAllOrderListSuccess(response?.data?.data[0]));
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callback);
  }
}
function* GetAllPendingOrderSaga(action) {
  try {
    const response = yield call(GetAllOrderApi, action.payload);
    if (response?.status === 200) {
      yield put(ActionGetAllPendingOrderListSuccess(response?.data?.data?.[0]));
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callback);
  }
}

function* GetAllCancelledOrderSaga(action) {
  try {
    const response = yield call(GetAllCancelledOrderApi, action.payload);
    if (response?.status === 200) {
      yield put(ActionGetAllCancelledOrderListSuccess(response?.data?.data?.[0]));
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callback);
  }
}

function* CreateOrderSaga(action) {
  try {
    const response = yield call(CreateOrderApi, action.payload);
    if (response) {
      action?.callBack(response?.data);
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}

function* GetOrderByIDSaga(action) {
  try {
    const response = yield call(GetOrderByIdApi, action.payload);
    if (response?.status === 200) {
      yield put(ActionGetOrderByIDSuccess(response?.data?.data));
      if (action?.callBack) {
        action?.callBack(response?.data);
      }
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack);
  }
}

function* CreatePaymentLinkSaga(action) {
  try {
    const response = yield call(CreatePaymentLinkApi, action.payload);
    if (response) {
      action?.callBack(response?.data);
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}

export function* OrderHistorySaga() {
  yield takeEvery(GET_ALL_ORDER_LIST, GetAllOrderSaga);
  yield takeEvery(GET_ALL_PENDING_ORDER_LIST, GetAllPendingOrderSaga);
  yield takeEvery(GET_ALL_CANCELLED_ORDER_LIST, GetAllCancelledOrderSaga);
  yield takeEvery(CREATE_ORDER, CreateOrderSaga);
  yield takeEvery(GET_ORDER_BY_ID, GetOrderByIDSaga);
  yield takeEvery('CREATE_PAYMENT_LINK', CreatePaymentLinkSaga);
}
